import { useEffect, useState } from 'react'

export default function useCurves(): Array<AssetCurves> {
    const [curves, setCurves] = useState([])
    useEffect(() => {
        const controller = new AbortController()
        const signal = controller.signal

        fetch('/services/plugin-liverig/curves/', { signal })
            .then(e => e.json())
            .then(e => {
                const fetchedCurves: Array<AssetCurves> = Object.entries(e).map(([mnemonic, entry]) => ({
                    ...entry,
                    mnemonic,
                    label: entry.description,
                    value: mnemonic
                }))
                setCurves(fetchedCurves)
            })
            .catch(e => console.error(e))

        return () => controller.abort()
    }, [])

    return curves
}
